import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import DataView from '../../common/DataView'
import EditableKioskField from './EditableKioskField'
import { timestampToDateString } from '../../../util/DateUtil'

export default function KioskInfoData({ kiosksState, editableFieldsRef }) {
  const { t } = useTranslation()
  const editableFields = useMemo(
    () => ['templeCode', 'locationType', 'locationDescription', 'langCode', 'authorized'],
    []
  )

  useEffect(() => {
    editableFieldsRef.current = editableFields.reduce((acc, field) => {
      acc[field] = kiosksState.selectedKiosk?.[field]
      return acc
    }, {})
  }, [editableFields, editableFieldsRef, kiosksState.selectedKiosk])

  const getDisplayValue = (fieldKey, fieldValue) => {
    switch (fieldKey) {
      case 'createDate':
      case 'updateDate':
        return timestampToDateString({ timestamp: fieldValue, timestampIsSeconds: true })
      default:
        return fieldValue
    }
  }

  const kioskInfoData = () => {
    return kiosksState.selectedKiosk
      ? Object.entries(kiosksState.selectedKiosk).map(([key, value]) => {
          return {
            label: t(`temple.kiosk.info.${key}`, key),
            detail: editableFields.includes(key) ? (
              <EditableKioskField
                fieldKey={key}
                value={value.toString()}
                isEditing={kiosksState.isEditMode}
                editableFieldsRef={editableFieldsRef}
                languages={kiosksState.languages}
              />
            ) : (
              getDisplayValue(key, value)
            ),
          }
        })
      : []
  }

  return <DataView id="kiosk-info" data={kioskInfoData()} />
}
